import { NotifyHelper } from "../../../helpers/toast";
import { eSanPhamPhamViActionTypeDefine } from "../../action-types/san-pham/ISanPhamPhamViActionType";
import { generateActionForKey, generateActions } from "../generateActions";

export const sanPhamPhamViActions = {
    ...generateActions(eSanPhamPhamViActionTypeDefine, "SAN_PHAM_PHAM_VI"),
    ...generateActionForKey(eSanPhamPhamViActionTypeDefine, "SAN_PHAM_PHAM_VI", "SAVE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eSanPhamPhamViActionTypeDefine, "SAN_PHAM_PHAM_VI", "DELETE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eSanPhamPhamViActionTypeDefine, "SAN_PHAM_PHAM_VI", "SAVE_ERROR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eSanPhamPhamViActionTypeDefine, "SAN_PHAM_PHAM_VI", "DELETE_ERROR", (m) => { NotifyHelper.Error(m) }),
}
